module.exports = __webpack_public_path__ + "img/menucn_4_4.1be33b44.svg";